export const exploreData = {
  sectionHeading: {
    tag: 'Explore',
    title: 'Stop overpaying',
    text: 'Fast & Simple Auto Insurance Quotes Tailored Just for You.'
  },
  exploreCards: [
    {
      id: 1,
      title: 'Less than three minutes',
      text: 'Enter your zip code and answer a few questions.'
    },
    {
      id: 2,
      title: 'Save Money',
      text: 'Get multiple offers from top insurers, so you can pick the best deal.'
    },
    {
      id: 3,
      title: 'Simple and free',
      text: 'You can save hundreds of dollars in just a few minutes.'
    }
  ]
}